const SITE = window.location.hostname.split('.')[0]
const GA_ID = 'G-516Q95WJZE'

function getUserId() {
  return JSON.parse(localStorage.getItem('loginUserData'))?.id ?? null
}

export function setUserId(id) {
  if (!window.gtag) return
  window.gtag('config', GA_ID, { user_id: id })
}

export function trackPageView(path, title) {
  if (!window.gtag) return
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
    site: SITE,
    user_id: getUserId(),
  })
}

export function trackEvent(name, params = {}) {
  if (!window.gtag) return
  window.gtag('event', name, { site: SITE, user_id: getUserId(), ...params })
}
